import { render } from "./BackButton.vue?vue&type=template&id=845e7194&scoped=true"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"

import "./BackButton.vue?vue&type=style&index=0&id=845e7194&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-845e7194"],['__file',"src/components/button/BackButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "845e7194"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('845e7194', __exports__)) {
    console.log('reload')
    api.reload('845e7194', __exports__)
  }
  
  module.hot.accept("./BackButton.vue?vue&type=template&id=845e7194&scoped=true", () => {
    console.log('re-render')
    api.rerender('845e7194', render)
  })

}


export default __exports__